module.exports = __webpack_public_path__ + "static/about1-7bbbc16186abfcebeb458e5b93642480.png";